
export { useCDALogin } from "/home/jenkins/agent/workspace/web-sunrise-prod/web-sunrise-grandiaziende-deploy-prod/libs/consumer/abroad/src/lib/hooks/useCDALogin.ts"